// extracted by mini-css-extract-plugin
export default {"app_nav__link":"styles_app_nav__link__ykuT5","app_nav__link_active":"styles_app_nav__link_active__r9Km7"};